/* eslint-disable no-console */
import { useUpdateEffect } from 'ahooks';
import { theme } from 'antd';

import { useGetAppSocket } from './useGetAppSocket';

const { colorSuccess, colorError } = theme.getDesignToken();

export const useInitAppSocket = () => {
  const { socket, error } = useGetAppSocket();

  socket.on('connect', () => {
    console.log(`%cApp sockets connected ID ${ socket.id }`, `color: ${ colorSuccess }; font-weight: bold; font-size: 12px;`);
  });

  socket.on('disconnect', () => {
    console.log('%cApp sockets disconnected', `color: ${ colorError }; font-weight: bold; font-size: 12px;`);
  });

  useUpdateEffect(() => {
    if (error) console.error(`App socket error: ${ error }`);
  }, [error]);
};
